import { apiClient } from './authService';

const instructorService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams ? `/instructors/?${queryParams}` : '/instructors/';
    const response = await apiClient.get(url);
    return response.data;
  },

  create: async (payload) => {
    const response = await apiClient.post('/instructors/', payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await apiClient.patch(`/instructors/${id}/`, payload);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/instructors/${id}/`);
    return response.data;
  },
};

export default instructorService;
